import { useMutation } from '@tanstack/react-query';
import { churchesService } from '@/services/churches.service';
import type { EvaSyncPreflightRequest } from '@/types/evaSync';

export const useEvaSyncPreflight = (churchId: string | undefined) => {
  return useMutation({
    mutationFn: (payload: EvaSyncPreflightRequest) =>
      churchesService.evaSyncPreflight(churchId ?? '', payload),
  });
};
